import { Injectable } from '@angular/core';
import { PtLuxonDate } from '../../models/projects/date.models';
import { JackingActivityRobFuelFigureEditor } from '../../models/projects/jacking-activity.models';
import { AppConfig } from '../../app/app.config';
import { HttpClient } from '@angular/common/http';
import { DateParserService } from '../daily-log/daily-log-time/date-parser-service';
import { TimeZoneService } from '../time-zone/time-zone.service';
import { Observable } from 'rxjs/Observable';
import { DateTime } from 'luxon';

@Injectable()
export class JackingActivityRobFigureService {
  config = AppConfig.settings;

  constructor(private http: HttpClient,
              private dateParserService: DateParserService,
              private timeZoneService: TimeZoneService) {
  }

  async getRobFuelFiguresForDay(dailyLogDate: PtLuxonDate): Promise<JackingActivityRobFuelFigureEditor[]>  {
    const dateLong = dailyLogDate.dateTime.toMillis();
    const url = `${this.config.apiUrl}api/jacking/rob-figures/${dateLong}`;
    const result = await this.http.get<JackingActivityRobFuelFigureEditor[]>(url).toPromise();
    return await this.deserializeFuelFigures(result);
  }

  private async deserializeFuelFigures(fuelFigures: JackingActivityRobFuelFigureEditor[]) {
    for (let i = 0; i < fuelFigures.length; i++) {
      fuelFigures[i].time = await this.dateParserService.deserializePtLuxonDate(fuelFigures[i].time, this.timeZoneService, fuelFigures[i].timeOffset);
    }

    return fuelFigures;
  }

  validate(fuelFigures: JackingActivityRobFuelFigureEditor[]): Observable<void> {
    for (let i = 0; i < fuelFigures.length; i++) {
      fuelFigures[i].time.dateTime = this.dateParserService.removeOffsetFromLuxonDate(fuelFigures[i].time.dateTime);
    }

    const url = `${this.config.apiUrl}api/jacking/rob-figures/validate`;
    return this.http.post<void>(url, fuelFigures);
  }

  saveFuelFigures(fuelFigures: JackingActivityRobFuelFigureEditor[]): Observable<void> {
    const url = `${this.config.apiUrl}api/jacking/rob-figures/save`;
    return this.http.post<void>(url, fuelFigures);
  }

  getOutstandingRobFigureGridDataConfig() {
    const url = `${AppConfig.settings.apiUrl}api/jacking/rob-figures/outstanding/grid/data`;
    return { name: 'rob-figures-outstanding-grid', url: url };
  }

  async checkOutstandingRobFuelFigures(dailyLogDate: DateTime): Promise<boolean> {
    // toMillis removes offset
    const dateLong = dailyLogDate.toMillis();
    const url = `${this.config.apiUrl}api/jacking/rob-figures/${dateLong}/checkoutstanding`;

    return await this.http.get<boolean>(url).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/services/jacking-activity/jacking-activity-rob-figure.service.ts